// src/types/color.ts
var AOColor = /* @__PURE__ */ ((AOColor2) => {
  AOColor2["BlueDark"] = "blue-dark";
  AOColor2["Blue"] = "blue";
  AOColor2["SteelDark"] = "steel-dark";
  AOColor2["Steel"] = "steel";
  AOColor2["AttentionDark"] = "attention-dark";
  AOColor2["Attention"] = "attention";
  AOColor2["AttentionLight"] = "attention-light";
  AOColor2["Sky"] = "sky";
  AOColor2["SkyLight"] = "sky-light";
  AOColor2["Cobalt"] = "cobalt";
  AOColor2["CobaltFaded"] = "cobalt-faded";
  AOColor2["Green"] = "green";
  AOColor2["GreenFaded"] = "green-faded";
  AOColor2["Orange"] = "orange";
  AOColor2["OrangeFaded"] = "orange-faded";
  AOColor2["Red"] = "red";
  AOColor2["RedFaded"] = "red-faded";
  AOColor2["Charcoal"] = "charcoal";
  AOColor2["Graphite"] = "graphite";
  AOColor2["Ash"] = "ash";
  AOColor2["Smoke"] = "smoke";
  AOColor2["Fog"] = "fog";
  AOColor2["White"] = "white";
  AOColor2["TextPrimary"] = "text-primary";
  AOColor2["TextSecondary"] = "text-secondary";
  return AOColor2;
})(AOColor || {});
function getCssColorString(color) {
  if (color === void 0) {
    return "";
  }
  if (color.startsWith(`--`)) {
    return `var(${color})`;
  } else if (Object.values(AOColor).includes(color)) {
    return `var(--ao-color-${color})`;
  } else {
    return `${color}`;
  }
}

export {
  AOColor,
  getCssColorString
};
